import { Component } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import api from "../../../utils/axios";
import { encodeValue, showDateTime, showContaimerLoader, apiDate, showAlert, hideLoader, showHTMLText, showLoader, validateDate, jsUcfirstFun, hasPermission } from "../../Settings/Settings";
import { s3Link } from "../../Settings/Config";
import { subDays } from "date-fns";
import $ from "jquery";
const module = "discussion";
const moduleID = 19;
class Personal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      showDiscusstionFrm: false,
      avb_date: "",
      las_date: "",
      last_salary: "",
      last_company: "",
      c_rank: "",
      c_vessel: "",
      active_details: "",
      ntbr: "",
      discussionStatus: "",
      companyname: "",
      errcompanyname: false,
      join_date: "",
      errjoin_date: false,
      errapproved_document: "",
      reason: "",
      discussionComments: "",
      specialComment: false,
      setReminder: false,
      reminder: "",
      referenceCheck: false,
      discussionplatform: "",
      discussionconnected: "",
      r_date: "",
      ref_check: "",
      candidateDetails: "",
      viewDocumentFile: "",
      errdiscussionComments: "",
    };
  }

  componentDidMount() {
    this.loadList();
    this.setState({
      loading: true,
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.candidateDetails !== nextProps.candidateDetails) {
      this.setState({ candidateDetails: nextProps.candidateDetails }, () => {
        const candidateDetails = nextProps.candidateDetails;
        const c_rank = candidateDetails.c_rank;
        const c_vessel = candidateDetails.c_vessel;
        const active_details = candidateDetails.active_details === 1 ? "Active" : "In Active";
        const status =
          candidateDetails.active_details !== "" && candidateDetails.active_details !== null
            ? {
                label: active_details,
                value: candidateDetails.active_details,
              }
            : "";
        let ntbr = "";
        if (candidateDetails.ntbr === "1") {
          ntbr = { value: 1, label: "Not to be re-employed by the owners/clients" };
        } else if (candidateDetails.ntbr === "0") {
          ntbr = { value: 0, label: "Not to be re-employed by Nautilus" };
        }

        this.setState({
          loading: true,
          avb_date: validateDate(candidateDetails.avb_date),
          las_date: validateDate(candidateDetails.las_date),
          last_salary: candidateDetails.last_salary,
          last_company: candidateDetails.last_company,
          c_rank: c_rank !== "" && c_rank !== null ? { label: c_rank, value: c_rank } : "",
          c_vessel: c_vessel !== "" && c_vessel !== null ? { label: c_vessel, value: c_vessel } : "",
          active_details: status,
          ntbr: ntbr,
        });
      });
    }
  }

  handleSelectChange(name, value) {
    this.setState({ [name]: value, [`err${name}`]: false });
  }
  handleChangeText(name, event) {
    const value = event.target.value;
    this.setState({ [name]: value, [`err${name}`]: false });
  }

  handleChangeCheckbox(name, event) {
    const checked = event.target.checked;
    this.setState({ [name]: checked });
  }
  loadList() {
    let addParams = "";
    try {
      api
        .get(`${module}/${this.props.candidateID}?${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      console.log(e);
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  saveDiscussion() {
    const discussionStatus = this.state.discussionStatus;
    const companyname = this.state.companyname?.value || "";
    const join_date = this.state.join_date;
    const reason = this.state.reason;
    const discussionComments = this.state.discussionComments;
    const specialComment = this.state.specialComment;
    const setReminder = this.state.setReminder;
    const referenceCheck = this.state.referenceCheck;
    const discussionconnected = this.state.discussionconnected?.value || "";
    const r_date = this.state.r_date;
    const ref_check = this.state.ref_check;
    const discussionplatform = this.state.discussionplatform?.value || "";

    if (!discussionStatus && !companyname && !join_date && !reason && !discussionComments && !specialComment && !setReminder && !referenceCheck && !discussionconnected && !r_date && !ref_check) {
      showAlert("Error", "Please enter discussion", "error");
      return false;
    }

    let error = 0;

    const fileInput = document.getElementById("approved_document");
    const file = fileInput?.files?.[0];

    if (discussionStatus) {
      if (this.state.companyname === "") {
        this.setState({ errcompanyname: true });
        error++;
      }
      if (this.state.join_date === "") {
        this.setState({ errjoin_date: true });
        error++;
      }
      if (discussionStatus === "Approved") {
        if (!file) {
          this.setState({ errapproved_document: "This field is required" });
          error++;
        } else if (file.type !== "application/pdf") {
          this.setState({ errapproved_document: "Document PDF only allowed" });
          error++;
        }

        if (this.state.discussionComments === "") {
          this.setState({ errdiscussionComments: "This field is required" });
          error++;
        } else {
          this.setState({ errdiscussionComments: "" });
        }
      }
    }
    if (error === 0) {
      showLoader("saveDiscussion");
      const postObject = {
        discussionStatus: this.state.discussionStatus,
        companyname: this.state.companyname?.label || "",
        companyID: companyname,
        join_date: apiDate(this.state.join_date),
        reason: this.state.reason,
        discussionComments,
        specialComment,
        setReminder,
        referenceCheck,
        discussionconnected,
        discussionplatform,
        r_date: apiDate(this.state.r_date),
        reminderText: this.state.reminder,
        ref_check: this.state.ref_check,
      };
      const formPayload = new FormData();
      Object.keys(postObject).forEach((key) => {
        formPayload.append(key, postObject[key]);
      });

      if (file) {
        if (file.type !== "application/pdf") {
          error += "Document PDF only allowed";
        } else {
          formPayload.append("approved_document", file);
        }
      }

      const post_url = `${module}/${encodeValue(this.props.candidateID)}`;

      api
        .post(post_url, formPayload)
        .then((res) => {
          hideLoader("saveDiscussion");
          const errMsg = res.data.message;
          if (res.data.status === "ok") {
            showAlert("Success", errMsg, "success", "No");
            this.setState({ listdata: [res.data.result, ...this.state.listdata] });
            setTimeout(() => {
              this.resetFrom();
            }, 1000);
          } else {
            showAlert("Error", errMsg, "error", "No");
          }
        })
        .catch((err) => {
          hideLoader("saveDiscussion");
          const errMsg = err.response.data?.message || err?.message;
          showAlert("Error", errMsg, "error", "No");
          console.error(err);
        });
    } else {
      setTimeout(() => {
        if ($(".error").length > 0) {
          $("html, body").animate(
            {
              scrollTop: $(document).find(".error:first").offset().top - 100,
            },
            500,
          );
        }
      });
    }
  }
  updateCandidate() {
    showLoader("updateCandidate");
    const postObject = {
      avb_date: apiDate(this.state.avb_date),
      las_date: apiDate(this.state.las_date),
      last_salary: this.state.last_salary,
      last_company: this.state.last_company,
      c_rank: this.state.c_rank?.value || "",
      c_vessel: this.state.c_vessel?.value || "",
      active_details: this.state.active_details?.value || "",
      ntbr: this.state.ntbr?.value ?? "",
    };

    const post_url = `candidate/updatelastcall/${encodeValue(this.props.candidateID)}`;

    api
      .put(post_url, postObject)
      .then((res) => {
        hideLoader("updateCandidate");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          this.props.sateValChange("loadCandidateDetails", "Yes");
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      })
      .catch((err) => {
        hideLoader("updateCandidate");
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  }
  resetFrom() {
    this.setState({
      discussionStatus: "",
      companyname: "",
      errcompanyname: false,
      join_date: "",
      errjoin_date: false,
      errapproved_document: "",
      reason: "",
      discussionComments: "",
      specialComment: false,
      setReminder: false,
      referenceCheck: false,
      discussionconnected: "",
      r_date: "",
      ref_check: "",
      errdiscussionComments:""
    });
  }
  viewFile(viewDocumentFile, e) {
    e.preventDefault();
    this.setState({ viewDocumentFile }, () => {
      $("#viewDoc").trigger("click");
    });
  }
  closePopup(e) {
    e.preventDefault();
    this.setState({ viewDocumentFile: "" });
  }

  render() {
    const specialComment_ = this.state.listdata.find((item) => item.discussion && item.discussion.includes("Special Comment"));

    return (
      <div className="container-fluid">
        <div className="page-header">
          <div className="page-title"></div>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className={`btn btn-sm btn-success badge mx-4`}
                    type="button"
                    onClick={() => {
                      this.setState({ showDiscusstionFrm: !this.state.showDiscusstionFrm });
                      this.resetFrom();
                    }}
                  >
                    {!this.state.showDiscusstionFrm ? (
                      <>
                        <i className="fa fa-plus"></i> Create New Discussion
                      </>
                    ) : (
                      `Close Discussion`
                    )}
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>

        <button
          className="btn btn-sm btn-success badge mx-4 hidden"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#extralargeviewDocmodal"
          data-backdrop="static"
          data-keyboard="false"
          id="viewDoc"
        >
          dd New
        </button>

        {specialComment_ && (
          <div className="row">
            <div className="col-12">
              <div className="card border-warning">
                <div className="card-header bg-warning-transparent">
                  <h4 className="card-title mb-0">
                    <i className="fa fa-star me-2" aria-hidden="true"></i>
                    Special Comment
                  </h4>
                </div>
                <div className="card-body">
                  <div className="alert alert-warning mb-0">
                    <div className="card-header" style={{ border: 0, padding: 0, background: "transparent" }}>
                      <strong className="text-primary">{jsUcfirstFun(specialComment_.User?.userName || "")}</strong>{" "}
                      <small className="text-muted card-options">{showDateTime(specialComment_.created_date)}</small>
                    </div>
                    <p className="mb-0">{showHTMLText(specialComment_?.discussion || "")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showDiscusstionFrm && (
          <div className="row">
            <div className="col-xl-6 col-lg-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Last Call</h4>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-5">
                      <label className="form-label">AVAILABLE DATE</label>
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select Available Date"
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                        selected={this.state.avb_date}
                        dateFormat="dd-MM-yyyy"
                        todayButton="Today"
                        onChange={this.handleSelectChange.bind(this, "avb_date")}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">LAST DATE</label>
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select Last Date"
                        className="form-control"
                        onKeyDown={(e) => e.preventDefault()}
                        selected={this.state.las_date}
                        dateFormat="dd-MM-yyyy"
                        todayButton="Today"
                        onChange={this.handleSelectChange.bind(this, "las_date")}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">LAST SALARY</label>
                      <input type="text" className="form-control" value={this.state.last_salary} onChange={this.handleChangeText.bind(this, "last_salary")} />
                    </div>

                    <div className="form-group col-md-5">
                      <label className="form-label">LAST COMPANY</label>
                      <input type="text" className="form-control" value={this.state.last_company} onChange={this.handleChangeText.bind(this, "last_company")} />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">RANK</label>
                      <Select value={this.state.c_rank} onChange={this.handleSelectChange.bind(this, "c_rank")} placeholder="Select Rank" isClearable={true} options={this.props.rankList} />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">VESSEL TYPE</label>
                      <Select
                        value={this.state.c_vessel}
                        onChange={this.handleSelectChange.bind(this, "c_vessel")}
                        placeholder="Select Vessel Type"
                        isClearable={true}
                        options={this.props.vessleTypeList}
                      />
                      {/* errMsgvesselType */}
                    </div>
                    <div className="form-group col-md-10">
                      <label className="form-label">RE-EMPLOYMENT</label>
                      <Select
                        value={this.state.ntbr}
                        onChange={this.handleSelectChange.bind(this, "ntbr")}
                        placeholder="Select Re-Employement"
                        isClearable={true}
                        options={[
                          { value: 0, label: "Not to be re-employed by Nautilus" },
                          { value: 1, label: "Not to be re-employed by the owners/clients" },
                        ]}
                      />
                      {/* errMsgStatus */}
                    </div>

                    <div className="form-group col-md-5">
                      <label className="form-label">
                        STATUS<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.active_details}
                        onChange={this.handleSelectChange.bind(this, "active_details")}
                        placeholder="Select Status"
                        isClearable={true}
                        options={[
                          { value: 1, label: "Active" },
                          { value: 0, label: "In Active" },
                        ]}
                      />
                      {/* errMsgStatus */}
                    </div>
                  </div>

                  <div className="text-end">
                    <button className="btn btn-primary" id="updateCandidate" onClick={this.updateCandidate.bind(this)}>
                      UPDATE
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Status</h4>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-md-3">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              name="discussionStatus"
                              value="Proposed"
                              onChange={this.handleChangeText.bind(this, "discussionStatus")}
                              checked={this.state.discussionStatus === "Proposed" ? true : false}
                            />
                            <span className="custom-control-label">Proposed</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-32">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              name="discussionStatus"
                              value="Approved"
                              onChange={this.handleChangeText.bind(this, "discussionStatus")}
                              checked={this.state.discussionStatus === "Approved" ? true : false}
                            />
                            <span className="custom-control-label">Approved</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-3">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              name="discussionStatus"
                              value="Joined"
                              onChange={this.handleChangeText.bind(this, "discussionStatus")}
                              checked={this.state.discussionStatus === "Joined" ? true : false}
                            />
                            <span className="custom-control-label">Joined</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-3">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              name="discussionStatus"
                              value="Rejected"
                              onChange={this.handleChangeText.bind(this, "discussionStatus")}
                              checked={this.state.discussionStatus === "Rejected" ? true : false}
                            />
                            <span className="custom-control-label">Rejected</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.discussionStatus !== "" && (
                    <div className="row">
                      <div className="form-group col-md-6">
                        <label className="form-label">COMPANY</label>
                        <Select
                          value={this.state.companyname}
                          onChange={this.handleSelectChange.bind(this, "companyname")}
                          placeholder="Select Company"
                          isClearable={true}
                          options={this.props.companyList}
                        />
                        {this.state.errcompanyname ? <span className="error">This field is required</span> : ""}
                      </div>
                      <div className="form-group col-md-5">
                        <label className="form-label">STATUS DATE</label>
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select Status Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.join_date}
                          dateFormat="dd-MM-yyyy"
                          onChange={this.handleSelectChange.bind(this, "join_date")}
                          maxDate={new Date()}
                        />
                        {this.state.errjoin_date ? <span className="error">This field is required</span> : ""}
                      </div>
                      {this.state.discussionStatus === "Approved" && (
                        <div className="form-group col-md-6">
                          <label className="form-label">APPROVED DOCUMENT</label>
                          <input
                            type="file"
                            className="form-control mb-3"
                            id="approved_document"
                            accept="application/pdf"
                            onChange={() => {
                              this.setState({ errapproved_document: "" });
                            }}
                          />
                          {this.state.errapproved_document ? <span className="error">{this.state.errapproved_document}</span> : ""}
                        </div>
                      )}
                      {this.state.discussionStatus === "Rejected" && (
                        <div className="form-group col-md-12">
                          <label className="form-label">REJECTED REASON</label>
                          <input type="text" className="form-control" placeholder="Rejected Reason" value={this.state.reason} onChange={this.handleChangeText.bind(this, "reason")} />
                        </div>
                      )}
                    </div>
                  )}

                  <hr />
                  <div className="row">
                    <div className="form-group col-md-5">
                      <label className="form-label">Via Platform</label>
                      <Select
                        value={this.state.discussionplatform}
                        onChange={this.handleSelectChange.bind(this, "discussionplatform")}
                        placeholder="Select Connected Status"
                        isClearable={true}
                        options={[
                          { value: "Call & Whatsapp", label: "Call & Whatsapp" },
                          { value: "Email", label: "Email" },
                          { value: "Seajobs", label: "Seajobs" },
                          { value: "Jobships", label: "Jobships" },
                          { value: "LinkedIn", label: "LinkedIn" },
                        ]}
                      />
                      {/* errMsgStatus */}
                    </div>
                  </div>
                  <div className="form-group col-md-12 mb-3">
                    <label className="form-label">COMMENTS</label>
                    <textarea className="form-control" rows="5" value={this.state.discussionComments} onChange={this.handleChangeText.bind(this, "discussionComments")}></textarea>
                    {this.state.errdiscussionComments ? <span className="error">{this.state.errdiscussionComments}</span> : ""}
                  </div>
                  <div className="row">
                    <div className="col-xl-4 col-md-4">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="specialComment"
                              onChange={this.handleChangeCheckbox.bind(this, "specialComment")}
                              checked={this.state.specialComment}
                            />
                            <span className="custom-control-label">Special Comment</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-checkbox">
                            <input type="checkbox" className="custom-control-input" name="setReminder" onChange={this.handleChangeCheckbox.bind(this, "setReminder")} checked={this.state.setReminder} />
                            <span className="custom-control-label">Set Reminder</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4">
                      <div className="form-group">
                        <div className="custom-controls-stacked">
                          <label className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name="referenceCheck"
                              onChange={this.handleChangeCheckbox.bind(this, "referenceCheck")}
                              checked={this.state.referenceCheck}
                            />
                            <span className="custom-control-label">Reference Check</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-5">
                      <label className="form-label">CONNECTED STATUS</label>
                      <Select
                        value={this.state.discussionconnected}
                        onChange={this.handleSelectChange.bind(this, "discussionconnected")}
                        placeholder="Select Connected Status"
                        isClearable={true}
                        options={[
                          { value: "Yes", label: "Connected" },
                          { value: "No", label: "Not Connected" },
                        ]}
                      />
                      {/* errMsgStatus */}
                    </div>
                  </div>
                  {this.state.setReminder && (
                    <div className="row">
                      <div className="form-group col-md-5">
                        <label className="form-label">REMINDER DATE</label>
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select Reminder Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.r_date}
                          dateFormat="dd-MM-yyyy"
                          onChange={this.handleSelectChange.bind(this, "r_date")}
                          minDate={new Date()}
                        />
                      </div>
                      <div className="form-group col-md-5">
                        <label className="form-label upper-case">Reminder Text</label>
                        <input type="text" className="form-control" placeholder="Reminder Text" value={this.state.reminder} onChange={this.handleChangeText.bind(this, "reminder")} />
                      </div>
                    </div>
                  )}
                  {this.state.referenceCheck && (
                    <div className="row">
                      <div className="form-group col-md-5">
                        <label className="form-label upper-case">Reference Check Text</label>
                        <input type="text" className="form-control" placeholder="Reference Check Text" value={this.state.ref_check} onChange={this.handleChangeText.bind(this, "ref_check")} />
                      </div>
                    </div>
                  )}
                  <div className="text-end">
                    <button className="btn btn-success" id="saveDiscussion" type="button" onClick={this.saveDiscussion.bind(this)}>
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Discussions</h4>
              </div>
              {this.state.loading
                ? showContaimerLoader()
                : this.state.listdata.length > 0 && (
                    <div className="card-body">
                      {this.state.listdata.map((item, index) => {
                        return (
                          <div key={index}>
                            <div className="d-flex mb-4">
                              <div className="flex-grow-1">
                                <div className="card-header" style={{ border: 0, padding: 0 }}>
                                  <strong className="text-primary">{jsUcfirstFun(item.User?.userName || "")}</strong> <small className="text-muted card-options">{showDateTime(item.created_date)}</small>
                                </div>

                                <p className="mb-1">{showHTMLText(item?.discussion || "")}</p>
                              </div>
                            </div>
                            {item.approved_document !== "" && item.approved_document !== null && (
                              <a href="/" onClick={this.viewFile.bind(this, item.approved_document)}>
                                View Approved Document
                              </a>
                            )}
                            {item.discussionplatform !== "" && item.discussionplatform !== null && (
                              <>
                                <br />
                                Via {item.discussionplatform} Platform
                              </>
                            )}
                            <hr />
                          </div>
                        );
                      })}
                    </div>
                  )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="extralargeviewDocmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">View Approved Document</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewDocumentFile !== "" ? (
                <div>
                  <iframe src={`${s3Link}discussion/${this.state.viewDocumentFile}`} width="100%" height="500px" title="view File"></iframe>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Personal;
